import React from 'react';
import List from './App/List';

const App = () => (
    <div className="app">
        <List />
    </div>
);

export default App;
